import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue';
import { CatalogsApi } from 'SharedDir/backend/api';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import SSelect from 'SharedComponents/ui/Select/SSelect.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'CatalogParameter' },
  __name: 'Catalog',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const { innerValue, emitValue } = useValue(props, emit);

const catalogs = ref([] as Array<unknown>);
const loading = ref(false);

onMounted(async () => {
  catalogs.value = await makeRequest(
    () => CatalogsApi.getAll({ sortBy: 'name', descending: false }),
    {
      startLoading: () => {
        loading.value = true;
      },
      finishLoading: () => {
        loading.value = false;
      },
    }
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SSelect, _mergeProps(_ctx.$attrs, {
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      _unref(emitValue)
    ],
    loading: loading.value,
    filtering: "",
    options: catalogs.value,
    "option-value": "slug",
    "option-label": "name",
    clearable: "",
    outlined: "",
    dense: "",
    "options-dense": "",
    "map-options": "",
    "emit-value": ""
  }), null, 16, ["modelValue", "loading", "options", "onUpdate:modelValue"]))
}
}

})